import GroupGiftRedemptionModal from './group-gift-redemption-modal'

export default GroupGiftRedemptionModal
